import type { inferQueryKeys } from '@lukemorales/query-key-factory';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { getAccountIntegrateSpecialAuditorAccount } from '../apiClient';

export const integrationQueries = createQueryKeys('integration', {
  specialAuditorAccount: () => ({
    queryKey: ['/accounts/integrate/special-auditor-account'],
    queryFn: () => getAccountIntegrateSpecialAuditorAccount(),
  }),
});

export type IntegrationQueries = inferQueryKeys<typeof integrationQueries>;
